import { WikiPage } from "../WikiPage";
export class WikiPageScanTreeEditing extends WikiPage {
    render() {
        this.todo();
    }
}
